import { inMiniprograme } from '@/utils/util'
import { usePortraitStore } from '@/composables/portrait/store'
import { isLogin } from '@/composables/user/users'
import { isIOS } from '@/utils/device'

export default defineNuxtRouteMiddleware((to, from) => {
  const nuxtApp = useNuxtApp()
  // const i18n = nuxtApp.$i18n // If using i18n instance

  // NProgress is handled by NuxtLoadingIndicator usually, but if using nprogress lib:
  // if (import.meta.client && !to.meta.noLoading) NProgress.start()

  const redirectUrl = useLocalStorage('redirectUrl', '')




  const toUrl = to.fullPath
  const fromUrl = from.fullPath

  // 登录拦截逻辑
  if (fromUrl.includes('redirect=true') && toUrl.includes('/login')) {
    redirectUrl.value = fromUrl
  }

  // Custom navigation logic for Obituary Preview (from legacy router)
  if (toUrl.includes('/createObituary/preview') && fromUrl.includes('/obituary/')) {
    const router = useRouter()
    if (toUrl.includes('obituaryId=')) {
      router.go(-2)
    } else {
      router.go(-4)
    }
  }

  // Release Portrait Store on navigation if not keepPortraitStore
  if (!to.meta.keepPortraitStore && from.meta.keepPortraitStore) {
    const portraitStore = usePortraitStore()
    portraitStore.resetStore()
  }

  // Title handling (Basic migration, prefer useHead in pages)
  if (import.meta.client) {
    const i18n = useNuxtApp().$i18n
    const title = to.meta.title ? i18n.t(to.meta.title.toString()) : i18n.t('app.name')
    document.title = title

    // WeChat MiniProgram Sync
    if (inMiniprograme.value) {
      import('weixin-js-sdk')
        .then((module) => {
          const wx = (module as any).default || module
          wx?.miniProgram?.postMessage?.({
            data: { url: to.fullPath }
          })
        })
        .catch(() => {})
    }
  }
})
